export default __webpack_public_path__ + "static/media/egg_video03.3691e61f.jpg";